export default __webpack_public_path__ + "static/wkr-91c29f6078fbd21ead1007370ebf1943.jpg";